import React from 'react'
import { StatusLabel, DeemphasizedLink } from '@fielded/shared-ui'
import { Arrow, ExclamationTriangle } from '@fielded/shared-ui/src/icons'

const VerificationStatus = ({ onVerify, showVerify = false }) => {
  if (!showVerify) {
    return null
  }

  return (
    <div className='vs-u-row vs-u-align-center vs-u-gap-half vs-u-margin-top-half'>
      <StatusLabel
        status='attention'
        label='Unverified'
        icon={<ExclamationTriangle />}
      />
      <DeemphasizedLink
        size='small'
        colorVariant='brand'
        iconSide='right'
        icon={<Arrow direction='right' />}
        onClick={onVerify}
        bold
      >
        Verify now
      </DeemphasizedLink>
    </div>
  )
}

export default VerificationStatus
